var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAppsDesktopActive = function SvgIcAppsDesktopActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-apps-desktop-active_svg__ic-apps-desktop-active",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 37,
    width: 48,
    height: 8,
    rx: 3,
    fill: "#FFE6D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 44,
    height: 32,
    rx: 4,
    fill: "#FFE6D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 38,
    height: 26,
    rx: 2,
    fill: "#FFC39C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 42,
    height: 5,
    rx: 2,
    fill: "#FFC39C"
  })));
};
export default SvgIcAppsDesktopActive;